import { useState, useEffect, useRef } from "react";
import ProfileHeader from "./ProfileHeader";
import { getProfileData } from "../../../service/api";
import { getIndustryData } from "../../../service/api";
import { getJobProfileData } from "../../../service/api";
import { getCityData } from "../../../service/api";
import { uploadProfileImage } from "../../../service/api";
import { uploadJobSeekerProfile } from "../../../service/api";
import Select from "react-select";
import { toast } from "react-toastify";

function EditProfile() {
  const [profile, setProfile] = useState({});
  const [btnloading, setBtnLoading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getProfileData();
        if (res.status && res.data) {
          setProfile(res.data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile((prev) => ({
          ...prev,
          image: reader.result,
          imageFile: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileUpload = async (e) => {
    e.preventDefault();

    if (!profile.imageFile) {
      alert("Please select an image first");
      return;
    }

    try {
      const res = await uploadProfileImage(profile.imageFile);
      if (res.data.status) {
        toast.success(res.data.message);
        setProfile((prev) => ({ ...prev, image: profile.image }));
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Upload failed");
    }
  };

  //  Industry
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await getIndustryData();
        setIndustries(response.data?.data); // set the array from API
      } catch (err) {
        console.error("Error fetching industries:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchIndustries();
  }, []);

  const industryOptions = industries.map((ind) => ({
    value: ind.name,
    label: ind.name,
  }));

  //  Job Profile
  const [jobprofile, setJobprofile] = useState([]);

  useEffect(() => {
    const fetchJobProfile = async () => {
      try {
        const response = await getJobProfileData();
        setJobprofile(response.data); // set the array from API
      } catch (err) {
        console.error("Error fetching job profile:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJobProfile();
  }, []);

  //  City
  const [cities, setCity] = useState([]);

  useEffect(() => {
    const fetchCity = async () => {
      try {
        const response = await getCityData();
        setCity(response.data); // set the array from API
      } catch (err) {
        console.error("Error fetching city:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCity();
  }, []);

  const options = cities.map((city) => ({ value: city, label: city }));

  const [isExperienced, setIsExperienced] = useState(false);
  const [currentSalary, setCurrentSalary] = useState("");
  const [salaryType, setSalaryType] = useState("");

  // useEffect(() => {
  //   if (profile.isExperienced !== undefined)
  //     setIsExperienced(profile.isExperienced);
  //   setCurrentSalary(profile.CurrentSalary || "");
  //   setSalaryType(profile.salaryType || "");
  // }, [profile]);

  useEffect(() => {
    if (profile.isExperienced !== undefined) {
      setIsExperienced(profile.isExperienced);
    }

    setCurrentSalary(profile.CurrentSalary ?? profile.currentSalary ?? "");

    setSalaryType(profile.salaryType ?? profile.SalaryType ?? "");
  }, [profile]);

  const handleProfileDetailsUpload = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);

      const profileData = {
        jobProfile: profile.jobProfile,
        name: profile.name,
        dateOfBirth: profile.dateOfBirth,
        gender: profile.gender,
        industryType: profile.industryType,
        alternatePhoneNumber: profile.alternatePhoneNumber,
        email: profile.email,
        city: profile.city,
        pincode: profile.pincode,
        DPAgreement: profile.DPAgreement || false,
      };

      if (isExperienced) {
        profileData.CurrentSalary = Number(currentSalary);
        profileData.salaryType = salaryType; // 🔥 MUST be lowercase
        profileData.isExperienced = true;
      } else {
        profileData.CurrentSalary = null;
        profileData.salaryType = null;
        profileData.isExperienced = false;
      }
      // if (isExperienced == true) {
      //   if (currentSalary) profileData.CurrentSalary = currentSalary;
      //   if (salaryType) profileData.SalaryType = salaryType;
      //   profileData.isExperienced = true;
      // } else {
      //   profileData.CurrentSalary = null;
      //   profileData.SalaryType = null;
      //   profileData.isExperienced = false;
      // }
      // console.log("ppooi:", profileData);

      const response = await uploadJobSeekerProfile(profileData);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div>
      {/* <div className="titlSectionu userpaneltitle text-left position-relative">
        <h2>Edit Profile</h2>
        <p>Update Profile Details</p>
      </div> */}

      <div className="row">
        <div className="col-md-3 mb-3 d-flex justify-content-center profile-card align-item-center">
          <form onSubmit={handleProfileUpload} encType="multipart/form-data">
            <div className="avatar-upload">
              <div className="avatar-edit">
                <input
                  type="file"
                  name="image"
                  id="imageUpload"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                <label htmlFor="imageUpload"></label>
              </div>
              <div className="avatar-preview">
                <div
                  id="imagePreview"
                  style={{
                    backgroundImage: `url(${
                      profile.image || "/assets/img/candidate-profiles/img1.jpg"
                    })`,
                  }}
                ></div>
              </div>
            </div>
            <br></br>
            <button className="outlineBtn" type="submit">
              Update Image
            </button>
          </form>
        </div>

        <div className="col-md-9 mb-3">
          <form onSubmit={handleProfileDetailsUpload}>
            <div className="row hj-form">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="">
                    Job Profile <span className="text-danger">*</span>
                  </label>
                  {/* <select
                    className="form-select"
                    name="jobProfile"
                    id="jobProfile"
                    value={profile.jobProfile || ""}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Job Profile</option>
                    {loading ? (
                      <option>Loading...</option>
                    ) : (
                      jobprofile.map((jobp) => (
                        <option key={jobp.name} value={jobp.name}>
                          {jobp.name}
                        </option>
                      ))
                    )}
                  </select> */}
                  <input
                    type="text"
                    className="form-control"
                    name="jobProfile"
                    value={profile.jobProfile}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    required=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="FullName">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={profile.name}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    required=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="dateOfBirth">
                    Date Of Birth <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="dateOfBirth"
                    value={profile.dateOfBirth}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    required=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="gender">
                    Gender <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="gender"
                    value={profile.gender}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="industry">
                    Industry Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    id="industry"
                    name="industryType"
                    isLoading={loading}
                    options={industryOptions}
                    value={
                      industryOptions.find(
                        (opt) => opt.value === profile.industryType,
                      ) || null
                    }
                    onChange={(selected) =>
                      setProfile((prev) => ({
                        ...prev,
                        industryType: selected?.value || "",
                      }))
                    }
                    isClearable
                    placeholder="Select Industry..."
                  />
                </div>
              </div>
              {/* <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="pan">
                PAN Card Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="pan"
                value={profile.panCardNumber}
                placeholder="PAN Card Number"
                required=""
                maxlength="10"
              />
            </div>
          </div> */}
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="alternatePhoneNumber">Alternate Phone</label>
                  <input
                    type="Mobile"
                    className="form-control"
                    name="alternatePhoneNumber"
                    value={profile.alternatePhoneNumber}
                    onChange={handleInputChange}
                    placeholder="Enter Mobile"
                    maxlength="10"
                    minlength="10"
                    pattern="\d{10}"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="email">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={profile.email}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    required=""
                  />
                </div>
              </div>

              {/* <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="address">
                Company Address <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="address"
                value=""
                placeholder="Enter Address"
                required=""
              />
            </div>
          </div> */}

              {/* <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="email">
                State <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="state"
                id="stateDropdown"
                required
              >
                <option value="">Select State</option>
                <option value=""></option>
              </select>
            </div>
          </div> */}

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="city">
                    City <span className="text-danger">*</span>
                  </label>
                  <Select
                    id="city"
                    name="city"
                    options={options}
                    value={
                      options.find((opt) => opt.value === profile.city) || null
                    }
                    onChange={(selected) =>
                      setProfile((prev) => ({
                        ...prev,
                        city: selected ? selected.value : "", // <-- handle null
                      }))
                    }
                    isClearable
                    placeholder="Select City..."
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="pincode">
                    Pincode <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="pincode"
                    value={profile.pincode}
                    onChange={handleInputChange}
                    placeholder="Enter Pincode"
                    required=""
                    maxlength="6"
                    minlength="6"
                  />
                </div>
              </div>

              {/* Experience */}
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="isExperienced">
                    Experience <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="isExperienced"
                    id="isExperienced"
                    value={isExperienced ? "true" : "false"}
                    onChange={(e) =>
                      setIsExperienced(e.target.value === "true")
                    }
                    required
                  >
                    <option value="false">Fresher</option>
                    <option value="true">Experienced</option>
                  </select>
                </div>
              </div>

              {/* Current Salary & Type */}
              {isExperienced && (
                <>
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="CurrentSalary">
                        Current Salary <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="CurrentSalary"
                        value={currentSalary} // <-- local state
                        placeholder="Enter Salary"
                        onChange={(e) => setCurrentSalary(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="SalaryType">
                        Salary Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="SalaryType"
                        value={salaryType} // <-- local state
                        onChange={(e) => setSalaryType(e.target.value)}
                      >
                        <option value="">Select Type</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Hourly">Hourly</option>
                      </select>
                    </div>
                  </div>
                </>
              )}

              {/* DP Agreement Checkbox */}
              <div className="col-12 mb-3">
                <div className="form-check d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-2 mb-2"
                    id="dpAgreement"
                    name="DPAgreement"
                    checked={profile.DPAgreement || false}
                    onChange={(e) =>
                      setProfile({
                        ...profile,
                        DPAgreement: e.target.checked,
                      })
                    }
                    required
                  />
                  <label className="form-check-label" htmlFor="dpAgreement">
                    I agree to the Data Processing (DP) Agreement *
                    <a
                      href="https://hourlee.in/data-processing-agreement"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ms-1"
                      style={{
                        textDecoration: "underline",
                        color: "#270b79",
                      }}
                    >
                      Read more
                    </a>
                  </label>
                </div>
              </div>

              <div className="col-md-12">
                <button
                  type="submit"
                  className="mt-4 w-100 normalbtn"
                  disabled={btnloading}
                >
                  {btnloading ? (
                    <span>
                      <i
                        className="fa fa-spinner fa-spin"
                        style={{ marginRight: "8px" }}
                      ></i>
                      Updating...
                    </span>
                  ) : (
                    "Update Profile"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditProfile;
